<template>
  <div
    class="section-mgn-btm recipient-list"
  >
    <div
      v-if="subject"
      class="recipient-list__subject"
    >
      <span class="small-mgn-right">{{ $t('subject') }}:</span>
      <span>{{ subject }}</span>
    </div>
    <div class="recipient-list__to">
      <span class="small-mgn-right">{{ $t('to') }}:</span>
      <span>{{ to }}</span>
    </div>
    <div class="recipient-list__cc">
      <span class="small-mgn-right">{{ $t('cc') }}:</span>
      <span>{{ cc }}</span>
    </div>
    <div class="recipient-list__bcc">
      <span class="small-mgn-right">{{ $t('bcc') }}:</span>
      <span>{{ bcc }}</span>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue-demi'

export default {
  props: {
    receivers: {
      type: Object,
      default: () => ({}),
    },
    subject: {
      type: String,
      default: '',
    },
  },
  setup (props) {
    return {
      to: computed(() => props.receivers.to),
      cc: computed(() => props.receivers.cc),
      bcc: computed(() => props.receivers.bcc),
    }
  },
  data () {
    return {

    }
  },
}
</script>

<style lang="scss" scoped>
  .recipient-list {
    word-wrap: break-word;
  }
  .section-mgn-btm {
    margin-bottom: 24px;
  }
  .small-mgn-right {
    margin-right: 5px;
  }
</style>
